import script from "./new-payment-method.vue?vue&type=script&lang=ts&setup=true"
export * from "./new-payment-method.vue?vue&type=script&lang=ts&setup=true"

import "./new-payment-method.vue?vue&type=style&index=0&id=3844ee22&lang=less"

const __exports__ = script;

export default __exports__